// Loader.tsx (дополненный)
import { useTheme } from "../../hooks/useTheme";
import styles from "./Loader.module.scss";

interface LoaderProps {
  size?: "small" | "medium" | "large";
  color?: string;
}

const Loader = ({ size = "medium", color }: LoaderProps) => {
  const { theme } = useTheme();
  const spinnerColor = color || theme.primary;

  const sizeMap = {
    small: 20,
    medium: 30,
    large: 40,
  };

  const spinnerSize = sizeMap[size];

  return (
    <div className={styles.container}>
      <div
        className={styles.spinner}
        style={{
          width: spinnerSize,
          height: spinnerSize,
          borderWidth: size === "small" ? 2 : 3,
          borderColor: `rgba(0,0,0,0.1)`,
          borderTopColor: spinnerColor,
          borderBottomColor: spinnerColor,
        }}
      />
    </div>
  );
};

export default Loader;